/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single list of numbers, one per line or separated by commas, tabs or spaces. Labels are not needed — the tool bins the raw values.`)
};

const es_hist_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una única lista de números, uno por línea o separados por comas, tabulaciones o espacios. No se necesitan etiquetas — la herramienta agrupa los valores en bruto.`)
};

const de_hist_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine einzelne Liste von Zahlen, eine pro Zeile oder getrennt durch Kommas, Tabulatoren oder Leerzeichen. Bezeichnungen werden nicht benötigt — das Tool teilt die Rohwerte in Klassen ein.`)
};

const nl_hist_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een enkele lijst getallen, één per regel of gescheiden door komma's, tabs of spaties. Labels zijn niet nodig — de tool deelt de ruwe waarden in.`)
};

const fr_hist_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une simple liste de nombres, un par ligne ou séparés par des virgules, des tabulations ou des espaces. Les étiquettes ne sont pas nécessaires — l'outil regroupe les valeurs brutes.`)
};

const it_hist_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un singolo elenco di numeri, uno per riga o separati da virgole, tabulazioni o spazi. Non servono etichette — lo strumento raggruppa i valori grezzi.`)
};

const pt_br2_hist_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma única lista de números, um por linha ou separados por vírgulas, tabulações ou espaços. Rótulos não são necessários — a ferramenta agrupa os valores brutos.`)
};

const pt_hist_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma lista simples de números, um por linha ou separados por vírgulas, tabulações ou espaços. Não são necessários rótulos — a ferramenta agrupa os valores brutos.`)
};

const ja_hist_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行に1つ、またはカンマ、タブ、スペースで区切られた数値の単一リストです。ラベルは不要で、ツールが生の値をビン分けします。`)
};

const zh_hist_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一组单纯的数字，每行一个，或用逗号、制表符或空格分隔。不需要标签——工具会直接对原始数值分箱。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_faq_a1", locale)
	if (locale === "en") return en_hist_faq_a1(inputs)
	if (locale === "es") return es_hist_faq_a1(inputs)
	if (locale === "de") return de_hist_faq_a1(inputs)
	if (locale === "nl") return nl_hist_faq_a1(inputs)
	if (locale === "fr") return fr_hist_faq_a1(inputs)
	if (locale === "it") return it_hist_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_hist_faq_a1(inputs)
	if (locale === "pt") return pt_hist_faq_a1(inputs)
	if (locale === "ja") return ja_hist_faq_a1(inputs)
	return zh_hist_faq_a1(inputs)
};